import CategoriaPedidoService from "@/services/CategoriaPedidoService";

export const categoriaPedido = {
  namespaced: true,
  state: {
    categoriaPedido: {},
  },
  actions: {
    getCategoriaPedido({ commit }, payload) {
      return CategoriaPedidoService.GetCategoriaPedido(payload).then(
        (categoriaPedido) => {
          return Promise.resolve(categoriaPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCategoriaPedido({ commit }, payload) {
      return CategoriaPedidoService.PostCategoriaPedido(payload).then(
        (categoriaPedido) => {
          return Promise.resolve(categoriaPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCategoriaPedido({ commit }, payload) {
      return CategoriaPedidoService.PutCategoriaPedido(payload).then(
        (categoriaPedido) => {
          return Promise.resolve(categoriaPedido);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCategoriaPedido({ commit }, payload) {
      return CategoriaPedidoService.DeleteCategoriaPedido(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCategoriaPedidoOData({ commit }, payload) {
      return CategoriaPedidoService.GetCategoriaPedidoOData(payload).then(
        (categoriaPedido) => {
          return Promise.resolve(categoriaPedido);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default categoriaPedido;
